import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import activityRouter from "./modules/activity.js";
import agencyRouter from "./modules/agency.js";
import shopRouter from "./modules/shop.js";
import appointmentRouter from "./modules/appointment.js";
import clerkRouter from "./modules/clerk.js";
import orderRouter from "./modules/order.js";
import comboRouter from "./modules/combo.js";
import inspectionRouter from "./modules/inspection.js";
import userRouter from "./modules/user.js";
import exwarehouse from "./modules/exwarehouse.js";
import subordinate from "./modules/subordinate.js";
import statistical from "./modules/statistical.js";
import cashbook from "./modules/cashbook.js";
import stock from "./modules/stock.js";


const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const routes = [
  {
    path: "/index",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/",
    name: "SweeCode",
    component: () => import("@/views/exwarehouse/index"),
    meta: {
      title: "哈弗商户服务系统"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/WxAuth",
    name: "WxAuth",
    component: () => import("../views/WxAuth.vue"),
    meta: {
      title: ""
    }
  },
  agencyRouter,
  shopRouter,
  activityRouter,
  appointmentRouter,
  clerkRouter,
  orderRouter,
  comboRouter,
  inspectionRouter,
  userRouter,
  exwarehouse,
  subordinate,
  statistical,
  cashbook,
  stock
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/cm-m/",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

export default router;